function Logo({ compact = false, onClick }) {
  return (
    <button
      aria-label="Gå til forsiden"
      className={`logo ${compact ? "compact" : ""}`}
      onClick={onClick}
      type="button"
    >
      <span>annoncen</span>
      <i aria-hidden="true" />
    </button>
  );
}

export default Logo;
